/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback } from 'react'
import { chatUnreadAPI, fetchChatCount, fetchChats, fetchChatsV2, fetchChatsV3, fetchFilteredTotalContactCount, fetchListAttributesAPI, fetchMessages } from '../../apis/APIs'
import ChatContext from './chatContext'
import { getLoggedUserInfo } from '../../basetool/methods'
import { WtLoginKey } from '../../constants/loginKeys'
import { listenFirebaseRealtimeDB } from '../../third-party/FireSocket'
import { useEffect } from 'react'
import moment from 'moment'

const ChatState = (props) => {
    // Chat Loader Management
    const [chatingStatus, setChatingStatus] = useState(false)
    const [loader, setLoader] = useState(true)
    // End of Chat Loader Management



    // Filter State Management
    const inboxFilterInitialVal = {
        "section": localStorage.getItem("ch_filterInbox_section") && localStorage.getItem("ch_filterInbox_section") !== "" ? localStorage.getItem("ch_filterInbox_section") : "inbox",
        "index": localStorage.getItem("ch_filterInbox_index") && localStorage.getItem("ch_filterInbox_index") !== "" ? parseInt(localStorage.getItem("ch_filterInbox_index")) : 0,
        "key": localStorage.getItem("ch_filterInbox_key") && localStorage.getItem("ch_filterInbox_key") !== "" ? localStorage.getItem("ch_filterInbox_key") : "all",
        "title": localStorage.getItem("ch_filterInbox_title") && localStorage.getItem("ch_filterInbox_title") !== "" ? localStorage.getItem("ch_filterInbox_title") : "All Chats"
    }
    const [inboxFilter, setInboxFilter] = useState(inboxFilterInitialVal)
    const [chatLsSeed, setChatLsSeed] = useState(1)
    const updateInboxFilter = useCallback((section, index, key, title) => {
        setChatListData([])
        localStorage.setItem("ch_filterInbox_section", section)
        localStorage.setItem("ch_filterInbox_index", index)
        localStorage.setItem("ch_filterInbox_key", key)
        localStorage.setItem("ch_filterInbox_title", title)
        setChatListSizeStatus(true)
        setInboxFilter(
            {
                "section": section,
                "index": index,
                "key": key,
                "title": title
            }
        )
        setChatLsSeed(Math.random())
    }, [])

    // End of Filter State Management




    // Chat Search Management
    const [searchValue, setSearchValue] = useState('')
    const handleSearchValue = (v) => setSearchValue(v)
    // End of Chat Search Management


    // Chat Selection List Work
    const [typeOfChatList, setTypeOfChatList] = useState('normal') // normal | filtered
    const handleTypeOfChatList = (val) => {
        setTypeOfChatList(val)
        if (val === 'normal') setChatFilteredListData([])
        if (val === 'filtered') setChatListData([])
    }

    const [chatListData, setChatListData] = useState([])
    const [chatListFilteredData, setChatFilteredListData] = useState([])
    // End of Chat Selection List Work


    // Chats State Management
    const [busyC, setBusyC] = useState(false)
    const [chatListSizeStatus, setChatListSizeStatus] = useState(true)



    const handleChatMasking = (filter, filterValue, chat) => {
        if (filter === 'inbox') {
            if (filterValue === 'all') {
                chat = chat?.filter(c => c?.hash || false)
            }
            if (filterValue === 'mine') {
                chat = chat?.filter(c => c?.empId === getLoggedUserInfo(WtLoginKey.userId) || false)
            }
            if (filterValue === 'unassigned') {
                chat = chat?.filter(c => !c?.empId || false)
            }
        }
        if (filter === 'channel') {
            chat = chat?.filter(c => c?.extChannelId === filterValue || false)
        }
        if (filter === 'label') {
            chat = chat?.filter(c => c?.user?.labels?.includes(filterValue) || false)
        }
        if (filter === 'search_filter') {
            chat = chat?.filter(c => c?.chatListType === filterValue || false)
        }
        setChatListData(chat)
    }
    const getChats = async (filter, filterValue, skip, limit, reason) => {
        handleTypeOfChatList('normal')
        if (localStorage.getItem('uHash') && localStorage.getItem('uHash') !== "") localStorage.removeItem('uHash')
        if (localStorage.getItem('isDemo') === 'true') setChatListData([])
        let allChats = []
        try {
            if (chatListSizeStatus) {
                let data = { "filter": filter, "filterValue": filterValue, "skip": skip, "limit": limit }
                // console.log(data)
                const response = await fetchChatsV2(data)
                if (response.status === 200) {
                    if (reason === "first_time") {
                        allChats = response.data.data
                        handleChatMasking(filter, filterValue, allChats)
                        setBusyC(false)
                    }
                    if (reason === "fetch_more") {
                        if (response.data.data?.length === 0) setChatListSizeStatus(false)
                        allChats = [...allChats, ...response.data.data]
                        handleChatMasking(filter, filterValue, allChats)
                        setBusyC(false)
                    }
                }
            }
            const _handleNewChat = (newChat) => {
                if (localStorage.getItem('isDemo') === 'true' && newChat?.extUserId !== localStorage.getItem('demoMobileNo')) return
                let chatIndex = allChats.findIndex(e => e.hash === newChat?.hash)
                if (chatIndex === -1) {
                    let nChat = [newChat]
                    allChats = [...chatListData, ...allChats, ...nChat]
                    handleChatMasking(filter, filterValue, [...allChats])
                } else {
                    allChats[chatIndex] = newChat
                    handleChatMasking(filter, filterValue, [...allChats])
                }
            }
            listenFirebaseRealtimeDB(getLoggedUserInfo(WtLoginKey.businessId), (listerner) => {
                if (listerner && listerner.messageUpdate && listerner.messageUpdate.chat) {
                    _handleNewChat(listerner.messageUpdate.chat)
                }
            })
        } catch (error) { }
    }
    const getChatsBySearch = async (searchVal) => {
        handleTypeOfChatList('normal')
        try {
            let data = { "filter": 'all', "searchText": searchVal, "skip": 0 }
            const response = await fetchChats(data)
            if (response.status === 200) {
                let newData = response.data.data?.map((v) => {
                    return { ...v, chatListType: "search_filter" }
                })
                handleChatMasking('search_filter', 'search_filter', newData)
            }
        } catch (error) { }
    }

    // End of Chats State Management


    // Chat Count Work
    const [chatCountData, setChatCountData] = useState([])
    const getChatCount = async () => {
        try {
            const response = await fetchChatCount()
            if (response.status === 200) setChatCountData(response.data.data)
        } catch (error) { }
    }
    useEffect(() => { getChatCount() }, [chatListData])
    // Chat Count Work



    // ChatInfo State Management
    const activeChatInfoInitialVal = {
        "name": undefined,
        "whatsapp": undefined,
        "channel": undefined,
        "channelName": undefined,
        "hash": undefined,
        "msgDate": undefined,
        "chatId": undefined,
        "unreadCount": undefined
    }
    const [msgSendAccess, setMsgSendAccess] = useState(undefined)
    const [activeChatInfo, setActiveChatInfo] = useState(activeChatInfoInitialVal)

    const updateActiveChatInfo = async (name, whatsapp, channel, channelName, hash, msgDate, chatId, unreadCount) => {
        setMessageLsData([])
        localStorage.setItem("uHash", hash)
        localStorage.setItem("activeChatWhatsApp", whatsapp)

        await getMessages(hash, 20, 0, "first_time")

        setActiveChatInfo(
            {
                "name": name,
                "whatsapp": whatsapp,
                "channel": channel,
                "channelName": channelName,
                "hash": hash,
                "msgDate": msgDate,
                "chatId": chatId,
                "unreadCount": unreadCount
            }
        )
        setMsgSendAccess(msgDate)
        if (unreadCount !== 0) await chatUnread(chatId)
    }
    // End of ChatInfo State Management



    // Chat UnRead State Management
    const chatUnread = async (id) => {
        try {
            let data = { 'chatId': id }
            await chatUnreadAPI(data)
        } catch (error) { }
    }
    // End of Chat UnRead State Management


    // Messages State Management
    const [busyM, setBusyM] = useState(false)
    const [messageLsData, setMessageLsData] = useState([])
    const [messageLsDataCount, setMessageLsDataCount] = useState(20)
    const getMessages = async (hash, limit, skip, reason) => {
        let allMessages = []
        try {
            let data = { 'hash': hash, 'limit': limit, 'skip': skip }
            const response = await fetchMessages(data)
            if (response.status === 200 && response.data?.data && response.data?.data?.count !== 0 && response.data?.data?.messages) {
                if (reason === "first_time") {
                    allMessages = response.data?.data?.messages
                    setMessageLsData(allMessages)
                    setBusyM(false)
                }
                if (reason === "fetch_more") {
                    allMessages = [...messageLsData, ...response.data?.data?.messages]
                    // let msg = allMessages.reverse()
                    setMessageLsData(allMessages)
                    setBusyM(false)
                }
                setMessageLsDataCount(response.data?.data?.count)
                setChatingStatus(true)
                setLoader(false)
            }
            const _handleNewMessage = (newMessage) => {
                if (localStorage.getItem("uHash") === newMessage?.hash) {
                    let messageIndex = allMessages.findIndex(e => e._id === newMessage?._id)
                    if (messageIndex === -1) {
                        allMessages.push(newMessage)
                    } else {
                        allMessages[messageIndex] = newMessage
                    }
                    setMessageLsData(allMessages)
                    if (newMessage?.fromId === localStorage.getItem("activeChatWhatsApp")) {
                        setMsgSendAccess(newMessage?.sentDate)
                    }
                }
            }
            listenFirebaseRealtimeDB(getLoggedUserInfo(WtLoginKey.businessId), (listerner) => {
                if (listerner && listerner.messageUpdate && listerner.messageUpdate.message) {
                    _handleNewMessage(listerner.messageUpdate.message)
                }
            })
        } catch (error) { }
    }
    // End of Messages State Management











    // Contact Filtering Work
    const [filterAppliedStatus, setFilterAppliedStatus] = useState(false)

    // Label Work
    const [labelFields, setLabelFields] = useState([{ l_id: "", l_action: "" }])
    const addLabelFields = () => {
        let newField = { l_id: "", l_action: "" }
        setLabelFields([...labelFields, newField])
    }
    const removeLabelFields = (index) => {
        let data = [...labelFields]
        data.splice(index, 1)
        setLabelFields(data)
        setApplyFilterStatus(true)
        setResetFilterStatus(true)
    }
    const updateLabelFieldsData = (index, event) => {
        let data = [...labelFields]
        data[index][event.target.name] = event.target.value
        setLabelFields(data)
        let status = data?.findIndex((v) => { return v['l_id'] === '' || v['l_action'] === '' })
        if (status === -1) {
            setApplyFilterStatus(true)
            setResetFilterStatus(true)
        } else {
            setApplyFilterStatus(false)
        }
    }
    const resetLabelFieldData = () => {
        setLabelFields([{ l_id: "", l_action: "" }])
    }
    // End of Label Work


    // Custom Field
    const [listCustomField, setListCustomField] = useState([])
    const getListCustomFieldLs = async (url) => {
        try {
            const response = await fetchListAttributesAPI(url)
            if (response.status === 200) setListCustomField(response.data.data[0].list)
        } catch (error) { }
    }

    const [customFields, setCustomFields] = useState([{ cf_id: "", cf_type: "", cf_key: "", cf_operator: "", cf_value: "" }])
    const addCustomFields = () => {
        let newField = { cf_id: "", cf_type: "", cf_key: "", cf_operator: "", cf_value: "" }
        setCustomFields([...customFields, newField])
    }
    const removeCustomFields = (index) => {
        let data = [...customFields]
        data.splice(index, 1)
        setCustomFields(data)
        setApplyFilterStatus(true)
        setResetFilterStatus(true)
    }
    const updateCustomFieldsData = (index, event) => {
        let data = [...customFields]
        let info = []
        if (event.target.name === 'cf_id') {
            info = event.target.value.split(',')
            data[index]['cf_id'] = info[0]
            data[index]['cf_type'] = info[1]
            data[index]['cf_key'] = info[2]

            if (info[1] === 'list') getListCustomFieldLs('?_id=' + info[0])
        } else {
            data[index][event.target.name] = event.target.value
        }

        setCustomFields(data)
        let status = data?.findIndex((v) => { return v['cf_id'] === '' || v['cf_type'] === '' || v['cf_key'] === '' || v['cf_operator'] === '' || v['cf_value'] === '' })
        if (status === -1) {
            setApplyFilterStatus(true)
            setResetFilterStatus(true)
        } else {
            setApplyFilterStatus(false)
        }
    }
    const resetCustomFieldData = () => {
        setCustomFields([{ cf_id: "", cf_type: "", cf_key: "", cf_operator: "", cf_value: "" }])
    }
    // End of Custom Field


    // Created At
    const dataStringConvertor = (val) => {
        let d1 = new Date(val)
        let d2 = d1.getTime()
        return d2
    }
    const [finalCreatedFrom, setFinalCreatedFrom] = useState('')
    const [finalCreatedTo, setFinalCreatedTo] = useState('')
    const [createAtOpt, setCreatedAtOpt] = useState('none')
    const [createdAtFrom, setCreatedAtFrom] = useState('')
    const [createdAtTo, setCreatedAtTo] = useState('')
    const updateCreatedAtOpt = (e) => {
        setCreatedAtFrom('')
        setCreatedAtTo('')
        setFinalCreatedFrom('')
        setFinalCreatedTo('')
        setCreatedAtOpt(e.target.value)
        if (e.target.value === "today") {
            setCreatedAtFrom(moment().format('L'))
            setCreatedAtTo(moment().format('LLL'))
            setFinalCreatedFrom(dataStringConvertor(moment().format('L')))
            setFinalCreatedTo(dataStringConvertor(moment().format('LLL')))
        }
        if (e.target.value === "week") {
            setCreatedAtFrom(moment().subtract(7, 'days').calendar())
            setCreatedAtTo(moment().format('L'))
            setFinalCreatedFrom(dataStringConvertor(moment().subtract(7, 'days').calendar()))
            setFinalCreatedTo(dataStringConvertor(moment().format('L')))
        }
        if (e.target.value === "month") {
            setCreatedAtFrom(moment().subtract(30, 'days').calendar())
            setCreatedAtTo(moment().format('L'))
            setFinalCreatedFrom(dataStringConvertor(moment().subtract(30, 'days').calendar()))
            setFinalCreatedTo(dataStringConvertor(moment().format('L')))
        }
        setApplyFilterStatus(true)
        setResetFilterStatus(true)
    }
    const updateCreatedAtOptFrom = (d) => {
        if (finalCreatedTo > dataStringConvertor(d) || finalCreatedTo === '') {
            setCreatedAtFrom(d)
            setFinalCreatedFrom(dataStringConvertor(d))
            setApplyFilterStatus(true)
            setResetFilterStatus(true)
        }
    }
    const updateCreatedAtOptTo = (d) => {
        if (finalCreatedFrom < dataStringConvertor(d)) {
            setCreatedAtTo(d)
            setFinalCreatedTo(dataStringConvertor(d))
            setApplyFilterStatus(true)
            setResetFilterStatus(true)
        }
    }
    const resetCreatedAtData = () => {
        setFinalCreatedFrom('')
        setFinalCreatedTo('')
        setCreatedAtOpt('none')
        setCreatedAtFrom('')
        setCreatedAtTo('')
    }
    // End of Created At


    // Last Seen
    const [finalLastSeenFrom, setFinalLastSeenFrom] = useState('')
    const [finalLastSeenTo, setFinalLastSeenTo] = useState('')
    const [lastSeenOpt, setLastSeenOpt] = useState('none')
    const [lastSeenFrom, setLastSeenFrom] = useState('')
    const [lastSeenTo, setLastSeenTo] = useState('')
    const updateLastSeenOpt = (e) => {
        setLastSeenFrom('')
        setLastSeenTo('')
        setFinalLastSeenFrom('')
        setFinalLastSeenTo('')
        setLastSeenOpt(e.target.value)
        if (e.target.value === "today") {
            setLastSeenFrom(moment().format('L'))
            setLastSeenTo(moment().format('LLL'))
            setFinalLastSeenFrom(dataStringConvertor(moment().format('L')))
            setFinalLastSeenTo(dataStringConvertor(moment().format('LLL')))
        }
        if (e.target.value === "week") {
            setLastSeenFrom(moment().subtract(7, 'days').calendar())
            setLastSeenTo(moment().format('L'))
            setFinalLastSeenFrom(dataStringConvertor(moment().subtract(7, 'days').calendar()))
            setFinalLastSeenTo(dataStringConvertor(moment().format('L')))
        }
        if (e.target.value === "month") {
            setLastSeenFrom(moment().subtract(30, 'days').calendar())
            setLastSeenTo(moment().format('L'))
            setFinalLastSeenFrom(dataStringConvertor(moment().subtract(30, 'days').calendar()))
            setFinalLastSeenTo(dataStringConvertor(moment().format('L')))
        }
        setApplyFilterStatus(true)
        setResetFilterStatus(true)
    }
    const updateLastSeenOptFrom = (d) => {
        if (finalLastSeenTo > dataStringConvertor(d) || finalLastSeenTo === '') {
            setLastSeenFrom(d)
            setFinalLastSeenFrom(dataStringConvertor(d))
            setApplyFilterStatus(true)
            setResetFilterStatus(true)
        }
    }
    const updateLastSeenOptTo = (d) => {
        if (finalLastSeenFrom < dataStringConvertor(d)) {
            setLastSeenTo(d)
            setFinalLastSeenTo(dataStringConvertor(d))
            setApplyFilterStatus(true)
            setResetFilterStatus(true)
        }
    }
    const resetLastSeenData = () => {
        setFinalLastSeenFrom('')
        setFinalLastSeenTo('')
        setLastSeenOpt('none')
        setLastSeenFrom('')
        setLastSeenTo('')
    }
    // End of Last Seen
    

    // Complete Reset
    const resetAllFilter = () => {
        // getTotalContactsCount()
        // handleWTLoader(true)
        setFilterAppliedStatus(false)
        resetLabelFieldData()
        resetCustomFieldData()
        resetCreatedAtData()
        resetLastSeenData()

        setApplyFilterStatus(false)
        setResetFilterStatus(true)
    }
    // End of Complete Reset


    // Opted In
    const [optedInOpt, setOptedInOpt] = useState('none')
    const handleOptedInOpt = (e) => { setOptedInOpt(e.target.value) }
    // End of Opted In



    const getChatsAppliedFilter = async (limit, skip, labelIdsInc, labelIdsExc, fieldList, createDateFrom, createDateTo, lastSeenFrom, lastSeenTo, reason) => {
        handleTypeOfChatList('filtered')
        try {
            let data = {
                'limit': limit,
                'skip': skip,
                "inboxFilter": "all",
                'labelIdsInc': (labelIdsInc === "") ? null : labelIdsInc,
                'labelIdsExc': (labelIdsExc === "") ? null : labelIdsExc,
                'fieldList': (fieldList === "") ? null : fieldList,
                'createDateFrom': (createDateFrom === "" || createDateFrom === undefined) ? null : createDateFrom,
                'createDateTo': (createDateTo === "" || createDateTo === undefined) ? null : createDateTo,
                'lastSeenFrom': (lastSeenFrom === "" || lastSeenFrom === undefined) ? null : lastSeenFrom,
                'lastSeenTo': (lastSeenTo === "" || lastSeenTo === undefined) ? null : lastSeenTo
            }

            const response = await fetchChatsV3(data)
            if (response.status === 200) {
                // console.log(reason)
                if (reason === "first_time") {
                    setChatFilteredListData(response.data.data)
                    setBusyC(false)
                }
                if (reason === "fetch_more") {
                    if (response.data.data?.length === 0) setChatListSizeStatus(false)
                    setChatFilteredListData([...chatListData, ...response.data.data])
                    setBusyC(false)
                }

                setApplyFilterStatus(false)
                setResetFilterStatus(false)
            } else { }
        } catch (error) { }
    }

    const getUnReadChatsAppliedFilter = async () => {
        handleTypeOfChatList('filtered')
        try {
            let data = {
                'limit': 1000,
                'skip': 0,
                "unreadFilter": true
            }

            const response = await fetchChatsV3(data)
            if (response.status === 200) {
                setChatFilteredListData(response.data.data)

                setApplyFilterStatus(false)
                setResetFilterStatus(false)
            } else { }
        } catch (error) { }
    }

    const [chatFilteredCount, setChatFilteredCount] = useState(0)
    const getFiltedContactsCount = async (labelIdsInc, labelIdsExc, fieldList, createDateFrom, createDateTo, lastSeenFrom, lastSeenTo) => {
        handleTypeOfChatList('filtered')
        try {
            let data = {
                'labelIdsInc': (labelIdsInc === "") ? null : labelIdsInc,
                'labelIdsExc': (labelIdsExc === "") ? null : labelIdsExc,
                'fieldList': (fieldList === "") ? null : fieldList,
                'createDateFrom': (createDateFrom === "" || createDateFrom === undefined) ? null : createDateFrom,
                'createDateTo': (createDateTo === "" || createDateTo === undefined) ? null : createDateTo,
                'lastSeenFrom': (lastSeenFrom === "" || lastSeenFrom === undefined) ? null : lastSeenFrom,
                'lastSeenTo': (lastSeenTo === "" || lastSeenTo === undefined) ? null : lastSeenTo
            }
            const response = await fetchFilteredTotalContactCount(data)
            if (response.status === 200) {
                setChatFilteredCount(response.data?.data?.totalContacts)
                // console.log(response.data?.data?.totalContacts)
            } else { }
        } catch (error) { }
    }

    const [applyFilterStatus, setApplyFilterStatus] = useState(false)
    const [resetFilterStatus, setResetFilterStatus] = useState(false)
    // End of Contact Filtering Work
    return (
        <ChatContext.Provider value={{
            typeOfChatList, handleTypeOfChatList,
            chatingStatus, setChatingStatus, loader, setLoader,


            inboxFilter, updateInboxFilter, chatLsSeed,
            searchValue, setSearchValue, handleSearchValue,
            chatCountData, getChatCount,
            busyC, setBusyC, chatListData, getChats, getChatsBySearch, chatListSizeStatus, setMessageLsData,
            activeChatInfo, setActiveChatInfo, updateActiveChatInfo, msgSendAccess,
            busyM, setBusyM, messageLsData, getMessages, messageLsDataCount,



            // Chat Filtering Work
            chatListFilteredData,

            filterAppliedStatus, setFilterAppliedStatus,

            labelFields, addLabelFields, removeLabelFields, updateLabelFieldsData, resetLabelFieldData,

            listCustomField, customFields, addCustomFields, removeCustomFields, updateCustomFieldsData, resetCustomFieldData,

            createAtOpt, updateCreatedAtOpt, createdAtFrom, updateCreatedAtOptFrom, createdAtTo, updateCreatedAtOptTo, finalCreatedFrom, finalCreatedTo, resetCreatedAtData,

            lastSeenOpt, updateLastSeenOpt, lastSeenFrom, updateLastSeenOptFrom, lastSeenTo, updateLastSeenOptTo, finalLastSeenFrom, finalLastSeenTo, resetLastSeenData,

            resetAllFilter,

            optedInOpt, handleOptedInOpt,

            getChatsAppliedFilter, getFiltedContactsCount, chatFilteredCount, getUnReadChatsAppliedFilter,

            applyFilterStatus, setApplyFilterStatus, resetFilterStatus, setResetFilterStatus
            // End of Chat Filtering Work
        }}>
            {props.children}
        </ChatContext.Provider>
    )
}
export default ChatState